module.exports = {
  All: '所有',
  Article: '文章',
  Catalog: '目录',
  Category: '目录',
  Categories: '目录',
  Comment: '评论',
  Comments: '评论',
  Language: '语言',
  Publish: '发布',
  Publishing: '发布中',
  Published: '已发布',
  Search: '搜索',
  Submit: '提交',
  Sorting: '排序',
  Tag: '标签',
  Tags: '标签',
  Url: '链接',
  'CMS(Base)': 'CMS(基本)',
  'Are You Sure?': '您确认吗？',
  'Article List': '文章清单',
  'Article List(by Category)': '文章清单(按目录)',
  'Category Name': '目录名称',
  'Comment Disabled': '禁止评论',
  'Create Article': '新建文章',
  'Language must not be Empty': '语言不允许为空',
  'Load More': '加载更多',
  'Post Comment': '发表评论',
  'Recent Comments': '最近评论',
  'Theme %s:%s:%s not Set': '没有设置主题%s:%s:%s',
  'Theme %s not Found': '没有找到主题%s',
  'CMS Block': 'CMS区块',
  PersonalProfile: '个人信息',
  AuthorProfile: '作者信息',
  ArticlePrevious: '前一篇',
  ArticleNext: '后一篇',
  Yes: '是',
  No: '否',
  Sticky: '置顶',
  Initialize: '初始化',
  'Render Files': '渲染文件',
  'Time Used': '用时',
  seconds: '秒',
  second2: '秒',
  Build: '构建',
  Block: '区块',
  'Build Site First': '请先构建站点',
  'Cannot delete if has children': '有子元素时不允许删除',
  'Cannot delete if has articles': '有文章时不允许删除',
  'CMS Article Publish': 'CMS文章发布',
};
